import type { DisplayModule } from '../../types/modules';
import Display from './Display';
import DisplaySkeleton from './DisplaySkeleton';

type Props = {
  module: DisplayModule;
  displayIndex: number;
  hasCloseButton?: boolean;
  hasBorderRadius: boolean;
};

function DisplayParser(props: Props) {
  const { module, displayIndex, hasCloseButton = false, hasBorderRadius } = props;

  if (module.displays === undefined)
    return (
      <DisplaySkeleton
        key={`ad-${displayIndex}`}
        bannerSpec={module.bannerSpec}
        hasBorderRadius={hasBorderRadius}
      />
    );

  if (module.displays[displayIndex])
    return (
      <Display
        key={`ad-${displayIndex}`}
        display={module.displays[displayIndex]}
        bannerSpec={module.bannerSpec}
        zoneId={module.zoneId as string}
        zoneCode={module.zoneCode}
        hasCloseButton={hasCloseButton}
        hasBorderRadius={hasBorderRadius}
      />
    );

  // display count< position count
  return <></>;
}

export default DisplayParser;
